module.exports = __webpack_public_path__ + "band_13.a8a6f479.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_13.png
// module id = TztX
// module chunks = 0